// Centralised theme deletion so both call sites share the same cache-invalidation and error-toasting contract.

import { toast } from "react-toastify";

import { fetcherSimple } from "utils/api";

export async function deleteTheme({
    surveyId,
    themeId,
    themesDataMutate,
    customResponsesFilterMutate,
    invalidateSurveyCaches,
}) {
    let response;
    try {
        response = await fetcherSimple(
            `/v2/survey/${surveyId}/theme/${themeId}`,
            "DELETE",
        );
    } catch (err) {
        toast.error(
            `Error deleting Theme, ${err?.message || "Unknown error"}`,
        );
        console.error(err);
        return false;
    }

    if (response?.deleted !== true) {
        const serverError =
            response?.error
                || (typeof response === "string"
                    ? response
                    : "Unknown issue deleting Theme.");
        toast.error(`Error deleting Theme, ${serverError}`);
        console.error(response?.errors || response);
        return false;
    }

    if (typeof themesDataMutate === "function") {
        themesDataMutate();
    }
    if (typeof customResponsesFilterMutate === "function") {
        customResponsesFilterMutate();
    }
    if (typeof invalidateSurveyCaches === "function") {
        invalidateSurveyCaches();
    }
    toast.success("Theme Deleted");
    return true;
}
